export const companyInfo = {
  name: 'Matheus Cleaning Service',
  logo: 'https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=95,format=auto/assets/682e08ab-395d-4160-a58a-7bbf165ed9e3/mcslogo-rez-sort.png',
  tagline: 'Premium Rengøring til Private & Erhverv',
  phone: '42 56 70 32',
  email: 'Luka2017@outlook.dk',
  address: 'Frankrigsgade 20 1. th., 2300 København S',
  cvr: '43120409', // If set to '0000000' or similar, it will be hidden
  openingHours: 'Mandag - Fredag: 08:00 - 17:00',
  description: 'Matheus Cleaning Service er et professionelt dansk rengøringsfirma, der leverer kompromisløs kvalitet og skræddersyede rengøringsløsninger til både private hjem og erhvervsvirksomheder. Vi vægter tillid, grundighed og miljøvenlige metoder højt.'
}

export const advantages = [
  {
    icon: 'fa-shield-check',
    title: '100% Tryghedsgaranti',
    description: 'Vi er fuldt forsikrede, og alle vores medarbejdere har ren straffeattest, så du trygt kan overlade dit hjem eller kontor til os.'
  },
  {
    icon: 'fa-sparkles',
    title: 'Kompromisløs Kvalitet',
    description: 'Vores erfarne rengøringsassistenter gennemgår grundig oplæring og arbejder efter faste, detaljerede kvalitetsprocedurer.'
  },
  {
    icon: 'fa-leaf',
    title: 'Miljøvenlige Produkter',
    description: 'Vi anvender skånsomme, svanemærkede rengøringsmidler, der beskytter både dit indeklima og vores fælles miljø.'
  },
  {
    icon: 'fa-calendar-check',
    title: 'Fleksible Aftaler',
    description: 'Uanset om du ønsker ugentlig, hver anden uge eller månedlig rengøring, tilpasser vi os fuldstændig dine behov.'
  }
]

export const services = {
  privat: {
    title: 'Privat rengøring',
    slug: 'privat-rengoering',
    intro: 'Oplev glæden ved at komme hjem til et skinnende rent og indbydende hjem. Vi skræddersyr rengøringen efter dine ønsker.',
    description: 'En travl hverdag kan gøre det svært at finde tid til den grundige rengøring. Hos Matheus Cleaning Service tilbyder vi professionel og pålidelig privat rengøring, der giver dig mere luft i kalenderen. Vi passer på dit hjem, som var det vores eget, og sikrer et fejlfrit resultat hver eneste gang.',
    advantages: [
      'Fast tilknyttet rengøringsassistent',
      'Skræddersyet rengøringsplan efter dine behov',
      'Svanemærkede og allergivenlige produkter',
      'Fuld forsikring og tryghedsgaranti'
    ],
    tasks: [
      'Aftørring af alle vandrette og lodrette overflader',
      'Støvsugning og gulvvask i alle rum',
      'Grundig rengøring af badeværelse (afkalkning, vask, toilet)',
      'Rengøring af køkken (udvendig aftørring af skabe, hvidevarer og bordplader)',
      'Tømning af skraldespande'
    ],
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/682e08ab-395d-4160-a58a-7bbf165ed9e3/residential-cleaning-living-room.jpg'
  },
  housekeeping: {
    title: 'Housekeeping',
    slug: 'housekeeping',
    intro: 'Eksklusiv ejendomsservice og hotel-standard pleje af dit hjem. Perfekt til dig, der ønsker det absolut bedste.',
    description: 'Vores housekeeping-service går et skridt videre end almindelig rengøring. Vi tilbyder en komplet pleje og vedligeholdelse af dit hjem med fokus på detaljen og den ekstra luksus i hverdagen. Med Matheus Cleaning Service Housekeeping får du en hotel-lignende oplevelse i dit eget hjem.',
    advantages: [
      'Eksklusiv hotel-standard i eget hjem',
      'Højeste diskretion og professionalisme',
      'Mulighed for tøjvask, strygning og opredning',
      'Perfekt til luksuslejligheder og store ejendomme'
    ],
    tasks: [
      'Skift af sengetøj og professionel opredning',
      'Vask, tørring og strygning af tøj og tekstiler',
      'Organisering og oprydning i skabe og skuffer',
      'Vanding af planter og blomsterpleje',
      'Klargøring af gæsteværelser og modtagelse af leverancer'
    ],
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/682e08ab-395d-4160-a58a-7bbf165ed9e3/housekeeping-hotel-apartment.jpg'
  },
  erhverv: {
    title: 'Erhvervsrengøring',
    slug: 'erhvervsrengoering',
    intro: 'Skab et sundt, præsentabelt og motiverende arbejdsmiljø for dine medarbejdere og kunder med professionel erhvervsrengøring.',
    description: 'Et rent arbejdsmiljø er afgørende for medarbejdernes trivsel, sundhed og produktivitet, samt for det indtryk, din virksomhed efterlader hos kunder og samarbejdspartnere. Vi leverer stabil, fleksibel og grundig erhvervsrengøring tilpasset jeres arbejdstider og lokaler.',
    advantages: [
      'Fleksible rengøringstider (før eller efter arbejdstid)',
      'Professionelle og uddannede erhvervsrengøringsfolk',
      'Fokus på hygiejne, touchpoints og indeklima',
      'Skræddersyet serviceaftale med fast kontaktperson'
    ],
    industries: [
      'Kontor- og administrationsbygninger',
      'Lægeklinikker, tandlæger og fysioterapeuter',
      'Butikker, showrooms og detailhandel',
      'Institutioner og uddannelsessteder',
      'Fællesarealer i boligforeninger'
    ],
    image: 'https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/682e08ab-395d-4160-a58a-7bbf165ed9e3/professional-cleaning-staff-office-no-logo.jpg'
  }
}

export const pricingPackages = [
  {
    name: 'Standard Rengøring',
    price: 'Fra 395 kr.',
    period: 'pr. time / inkl. moms',
    description: 'Perfekt til almindelig vedligeholdelse af private hjem.',
    features: [
      'Støvsugning & gulvvask',
      'Aftørring af frie overflader',
      'Rengøring af badeværelse',
      'Rengøring af køkken (udvendig)',
      'Svanemærkede midler inkluderet'
    ],
    cta: 'Bestil nu',
    popular: false
  },
  {
    name: 'Premium Rengøring',
    price: 'Fra 450 kr.',
    period: 'pr. time / inkl. moms',
    description: 'Vores mest populære pakke med ekstra fokus på detaljerne.',
    features: [
      'Alt fra Standard Rengøring',
      'Afkalkning af fliser & armaturer',
      'Indvendig aftørring af mikrobølgeovn',
      'Aftørring af paneler & døre',
      'Fast tilknyttet assistent'
    ],
    cta: 'Få et tilbud',
    popular: true
  },
  {
    name: 'Erhverv & Kontor',
    price: 'Indhent tilbud',
    period: 'Skræddersyet aftale',
    description: 'Professionel rengøring af kontorer og erhvervslokaler.',
    features: [
      'Fleksible arbejdstider',
      'Hygiejnisk aftørring af tastaturer & IT',
      'Tømning af affald & kildesortering',
      'Aftørring af fællesarealer & kantine',
      'Fast serviceleder & kvalitetskontrol'
    ],
    cta: 'Kontakt os',
    popular: false
  }
]
